export default function filterByIds(available, ids) {
  const idMap = new Set(ids);
  return available?.filter(({ id }) => idMap.has(id)) ?? [];
}
